import { defineAbility } from "@casl/ability";

const getUserPermissions = (user) =>
  defineAbility((can, cannot) => {
    if (user) can("manage", "all");

    switch (user?.role) {
      case "partner":
        cannot("manage", "User");
        cannot("create", "Company");
        cannot("delete", "Company");
        cannot("edit", "Company");
        cannot("manage", "List");
        cannot("manage", "ContentGroup");
        cannot("manage", "ContentParameter");
        break;
      case "analyst":
        cannot("manage", "User");
        cannot("access", "Company");
        cannot("manage", "List");
        cannot("manage", "ContentGroup");
        cannot("manage", "ContentParameter");
        cannot("manage", "Member");
        cannot("access", "Analytics");
        cannot("manage", "Report");
        cannot("log", "Agenda");
        cannot("review", "Newsletter");
        break;
    }
  });

export default getUserPermissions;
